import { Environment, parseEnvName } from './environment.type';

export const environment: Environment = {
  name: 'RAVEN',
  isProduction: true,
  envName: parseEnvName('Quality Assurance'),
  showEnv: parseShowEnv('True'),
  hmr: false,
  auth: {
    enabled: true,
    clientId: 'd54ea2e7-636f-4b02-83f1-77c98fb6b01d',
  },
  build: {
    tag: '',
    branchName: 'release-2026.13',
    buildNumber: '20261102.2',
  },
  appInsights: {
    connectionString: 'InstrumentationKey=9ff0c750-aaaa-4c5a-96d6-fc7ccac0a82f;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=e9bc36ee-a1f1-46c8-b66c-71e35a9da75d',
  },
  backend: {
    url: '/api',
  },
  support: {
    mail: {
      to: '',
    },
  },
};

export function parseShowEnv(showEnv: string): boolean {
  return showEnv == 'True';
}
